import { getDeviceIp } from './core-actions';

export const findDataInArrayStore =  (array, field, value) => {
    return  array.find(data => {
                if (data[field] === value) {
                    return true
                } else {
                    return false
                }
            })
}

export const validateIp = async  (ip, getDeviceData, updateIpDevice) => {
    try {
        // console.log('VALIDATE IP ', ip)
        if (ip === null ) {
            const ipSend = await getDeviceIp()
            updateIpDevice(ipSend)
            return ipSend
        } else if (ip === undefined) {
            const ipSend = await getDeviceIp()
            getDeviceData(null)
            return ipSend
        } else {
            return ip
        }
    } catch (error) {
        //console.log(error)

        return  await getDeviceIp()
    }
}